import HistoryLogList from './historyLogList'
export default HistoryLogList